<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    :return-value.sync="time"
    transition="scale-transition"
    offset-y
    min-width="290px"
    max-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="time"
        :label="label"
        prepend-icon="mdi-clock-time-four-outline"
        readonly
        outlined
        :rules="rules"
        v-bind="attrs"
        clearable
        v-on="on"
      ></v-text-field>
    </template>
    <v-time-picker
      v-if="menu"
      ref="timepicker"
      v-model="time"
      hide-details
      scrollable
      :rules="rules"
      :allowed-minutes="allowedStep"
      ampm-in-title
      @click:minute="handleMinuteClick"
    >
      <!--
      @input="updateValue" -->
      <template v-if="hasConfirmBtn">
        <v-spacer></v-spacer>
        <v-btn
          text
          color="primary"
          @click="menu = false"
        >
          Cancel
        </v-btn>
        <v-btn
          text
          color="primary"
          @click="updateValue"
        >
          OK
        </v-btn>
      </template>
    </v-time-picker>
  </v-menu>
</template>
<script>
import moment from '@/utils/moment'

export default {
  props: {
    typeConfig: {
      type: Object,
      default() {
        return {
        }
      },
    },
    value: {},
    label: {},
  },
  data: () => ({
    defaultDateFormat: 'yyyy-MM-DD',
    defaultTimeFormat: 'HH:mm',
    defaultDateTimeFormat: 'yyyy-MM-DDTHH:mm:ss.SSSZ',
    date: null,
    time: null,
    menu: false,
  }),
  computed: {
    rules() {
      return this.typeConfig.rules || []
    },
    hasConfirmBtn() {
      return this.typeConfig.hasConfirmBtn || false
    },
    dateFormat() {
      return this.typeConfig.dateFormat || this.defaultDateFormat
    },
    timeFormat() {
      return this.typeConfig.timeFormat || this.defaultTimeFormat
    },
    datetimeFormat() {
      return this.typeConfig.dateTimeFormat || this.defaultDateTimeFormat
    },
    dateValue() {
      return this.toDate(this.value1)
    },

    // timeValue() {
    //   return this.toTime(this.value2)
    // },
  },
  watch: {
    time(newvalue) {
      console.log('TimePicker newvalue', newvalue)
      this.updateValue(newvalue)
    },
    value(newvalue, oldvalue) {
      console.log('TimePicker newvalue', newvalue)
      if (newvalue) {
        this.time = moment(newvalue).format(this.timeFormat)
      } else {
        this.time = null
      }

      // console.log('timepicker newvalue', newvalue)
      // this.updateValue(newvalue)
    },
  },
  mounted() {
    console.log('Timepicker this.value', this.value)
    if (this.value) {
      this.date = this.value
      this.time = moment(this.value).format(this.timeFormat)
    }
  },
  methods: {
    handleMinuteClick() {
      this.$refs.menu.save(this.time)
    },
    allowedStep(m) {
      return m % (this.typeConfig.step || 30) === 0
    },
    updateValue(newvalue) {
      console.log('updateValue', newvalue)

      // this.date = this.toDate(newvalue)
      if (this.time) {
        this.$emit('input', this.toTime(newvalue, this.defaultDateTimeFormat))

        // this.$refs.menu.save(this.time)
      }
    },
    toTime(time, format) {
      // console.log('timeSpan', time)
      const timeSpan = moment.duration(time)

      let date = moment()
      if (this.date) {
        date = moment(this.date)
      }
      let mformat = this.timeFormat
      if (format) {
        mformat = format
      }

      return date.startOf('day').add(timeSpan)
        .format(mformat)
    },
  },
}
</script>
